// ----------------------------------------------------------------------

export const paths = {
  root: '/',
  ace: 'https://ace.code-engine.app',
  contact: 'mailto:contact@code-engine.net?subject=Book a Call',
  tnc: '/terms-and-conditions',
  privacy: '/privacy-policy',
  imprint: '/imprint',
  cookiePolicy: '/cookie-policy',
};
